import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M18.867 12.48A4.53 4.53 0 0 0 20 9.304v-.19a9.998 9.998 0 0 0-1.916-5.041A10.017 10.017 0 0 0 8.464.129a10.025 10.025 0 0 0-4.91 2.244A10.005 10.005 0 0 0 .25 12.22a10.002 10.002 0 0 0 2.566 4.744 10.021 10.021 0 0 0 4.66 2.725 19.9 19.9 0 0 0 4.007.31h1.152c.376 0 .735-.195.986-.474A1.47 1.47 0 0 0 14 18.507a1.5 1.5 0 0 0-1.5-1.5c-.399 0-.795-.167-1.076-.448a1.5 1.5 0 0 1 1.062-2.562h3.366a4.54 4.54 0 0 0 3.015-1.517zM12 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM5.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-1 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm10-4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
});

var SvgColorsMajor = function SvgColorsMajor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgColorsMajor as S };
